module.exports = __webpack_public_path__ + "static/popup-sale-logo-8959c8c1e01434bdba6310c5243c2e59.png";